
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Custom hook for filtering tables based on dropdown selection
 *
 * @file useTableFilter.js
 * @author Anuja Gaikwad
 * @since 1.4.7
 */


import { useMemo } from 'react';

const useTableFilter = ({
  data = [],
  search = '',
  columns = [],
  filterConfig,
  selectedFilter = 'all'
}) => {
  const filteredData = useMemo(() => {
    let filtered = [...data];

    // SEARCH
    if (search) {
      filtered = filtered.filter((item) => columns.some((column) => {
        if (!column.primarySearch) return false;

        const fields = Array.isArray(column.primarySearchFields)
          ? column.primarySearchFields
          : [column.primarySearchFields];

        return fields.some((field) => {
          const value = item[field];

          return (
            value &&
              value
                .toString()
                .toLowerCase()
                .includes(search.toLowerCase())
          );
        });
      })
      );
    }

    // FILTER
    if (
      filterConfig &&
      selectedFilter !== 'all'
    ) {
      const selectedOption = filterConfig.options.find(
        (option) => option.value === selectedFilter
      );

      if (selectedOption?.filters) {
        filtered = filtered.filter((item) => Object.entries(selectedOption.filters).every(
          ([field, expectedValue]) => item[field] === expectedValue
        )
        );
      }
    }

    return filtered;
  }, [
    data,
    search,
    columns,
    filterConfig,
    selectedFilter
  ]);

  return filteredData;
};

export default useTableFilter;
